import React from 'react';
import { Dialog, Pane, Text } from "evergreen-ui";
import { ContactUs } from "./Misc"


export let ErrorOrder = (props) => <Dialog
  isShown={true}
  title="Drawing Error"
  onCloseComplete={() => props.onClose}
  hasCancel={false}
  hasClose={true}
  confirmLabel={'Close'}
>
  <Pane display={'flex'} >
    <Pane display={"flex"} justifyContent={"center"} alignItems={"center"}>
      <div className="dxfsvf" dangerouslySetInnerHTML={{ __html: props.order.book.svg }} />
    </Pane>
    <Pane>
      <h1>{props.order.book.display}</h1>
      <Text>
        We regret to inform you that we have identified an issue with your DXF drawing.<br/>
        To ensure that we can provide you with the best solution, we kindly request that you please contact us and one of our dedicated team members will be happy to assist you in resolving this issue.<br/>
        <br/>
        Please do not hesitate to  <ContactUs>reach out to us</ContactUs>, we are here to help.
      </Text>

      <ul>
        {props.order.drawing.errors.map((error, i) => <li key={i}>#{i} <i>{error}</i></li>)}
      </ul>
    </Pane>
  </Pane>
</Dialog>;
